import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { clearClientAuthState } from "../../env";

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    clearClientAuthState();
  }, []);

  const handleLoginClick = () => {
    navigate("/login", { replace: true });
  };

  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-linear-to-b from-blue-50 to-white px-4">
      <div className="text-center max-w-md">
        {/* Success Icon */}
        <div className="mb-8 flex justify-center">
          <div className="relative w-24 h-24 bg-green-100 rounded-full flex items-center justify-center">
            <svg className="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{t("common.logoutSuccess")}</h1>
        <p className="text-lg text-gray-600 mb-8">{t("common.logoutMessage")}</p>

        {/* Login Button */}
        <button
          onClick={handleLoginClick}
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
        >
          {t("common.loginAgain")}
        </button>
      </div>
    </main>
  );
};

export default Logout;
